import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import moment from 'moment';

import { VersionHistory } from '../../reducers/page/versionHistory';
import { messages } from './Toolbar.messages';

export const getWarnText = (params: {
    company: selectors.types.ExpandedCompany;
    integrationType: domain.IntegrationType;
    hasIntegrationError: boolean;
    template: domain.Template;
    versionHistory: VersionHistory;
}) => {
    const { company, integrationType, hasIntegrationError, template, versionHistory } = params;

    if (hasIntegrationError) {
        return messages.disconnectionWarningText({
            integrationName: selectors.integration.getIntegrationTypeName(integrationType),
        });
    }

    if (company.flags.isRetired && company.isReadonly) {
        return messages.retiredWarningText;
    }

    if (company.flags.isExpired && company.flags.isTrialLicense && company.isReadonly) {
        return messages.trialExpiredWarningText;
    }

    if (company.flags.isExpired && company.isReadonly) {
        return messages.expiredWarningText;
    }

    if (template.isActual !== null && !template.isActual) {
        const templateData = versionHistory.templates.filter(
            (templateVersion) => templateVersion.version === template.version
        )[0];

        if (templateData?.createDate) {
            const name = templateData.author
                ? `${messages.modified} ${messages.by} ${templateData.author.firstName} ${templateData.author.lastName} `
                : `${messages.modified} `;
            const date = moment(templateData.createDate).format('ll');

            return (
                <>
                    {name}

                    {messages.on + ' '}

                    {date}
                </>
            );
        }
    }

    return null;
};
